<template>
  <div>
    <div>
      <v-btn class="primary" @click="close_council_dialog()">
        <v-icon>mdi-close</v-icon> Закрыть
      </v-btn>
    </div>

    <v-card v-if="(GETTERS_COUNCIL_ALL !== null) && (GETTERS_COUNCIL_ALL !== undefined)" class="main-card">
      <v-card-title text-color="#15336d">
        <v-container class="pa-0 pl-4">
          <v-row>
            <v-col cols="4" class="pt-8">
              <v-icon left color="#15336d">mdi-label</v-icon> {{GETTERS_COUNCIL_ALL.name}} от {{ GETTERS_COUNCIL_ALL.date }}
            </v-col>

            <v-col v-if="GETTERS_COUNCIL_ACCESS.is_moderator" style="max-width: 180px;">
              <div class="ml-4" v-if="edit_time_mode">
                <v-menu
                  ref="menu"
                  v-model="menu_time"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="start_time"
                  transition="scale-transition"
                  offset-y
                  max-width="220px"
                  min-width="220px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="start_time"
                      label="Время начала"
                      prepend-icon="mdi-clock-time-four-outline"
                      :color='$mainColor'
                      readonly
                      v-bind="attrs"
                      small
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu_time"
                    v-model="start_time"
                    full-width
                    locale='ru'

                    scrollable
                    :allowed-minutes="allowedStep"
                    class="mt-4"
                    format="24hr"

                    :color='$mainColor'
                    @click:minute="$refs.menu.save(start_time)"
                  />

                </v-menu>
              </div>
              <div class="ml-4" v-else>
                <v-text-field
                  v-model="start_time"
                  label="Время начала"
                  prepend-icon="mdi-clock-time-four-outline"
                  :color='$mainColor'
                  readonly
                  small
                ></v-text-field>
              </div>
            </v-col>
            <v-col v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
              <div v-if="(GETTERS_COUNCIL_ALL.status == 0 || GETTERS_COUNCIL_ALL.status == 1) && page_editable.can_edit">
                <div v-if="edit_time_mode">
                  <v-icon
                    class="ma-2"
                    small
                    color="red lighten-1"
                    @click="edit_time_mode = false; start_time = GETTERS_COUNCIL_ALL.start_time.substring(0,5)">
                    mdi-cancel
                  </v-icon>
                  <v-icon
                    class="ma-2"
                    small
                    color="green lighten-1"
                    @click="updateCouncilTime()">
                    mdi-content-save-check
                  </v-icon>
                </div>
                <div v-else>
                  <v-icon
                    class="ma-2"
                    small
                    color="red lighten-1"
                    @click="edit_time_mode = true">
                    mdi-pencil
                  </v-icon>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="GETTERS_COUNCIL_ALL.is_si" style="font-size: 14px;">
            <v-col cols="3" class="pa-0">
              <v-icon left>mdi-atom-variant</v-icon>КИСИ
            </v-col>
            <v-col cols="3" class="pa-0">
              {{ GETTERS_COUNCIL_ALL.si_session_name }}
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-icon left>mdi-calendar</v-icon><i>{{g.toDate(GETTERS_COUNCIL_ALL.si_session_start)}} - {{g.toDate(GETTERS_COUNCIL_ALL.si_session_end)}}</i> <br>
            </v-col>
          </v-row>
          <v-row v-if="GETTERS_COUNCIL_ALL.is_ir8" style="font-size: 14px;">
            <v-col cols="3" class="pa-0">
              <v-icon left>mdi-radioactive-circle</v-icon>ИР-8
            </v-col>
            <v-col cols="3" class="pa-0">
              {{ GETTERS_COUNCIL_ALL.ir8_session_name }}
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-icon left>mdi-calendar</v-icon><i>{{g.toDate(GETTERS_COUNCIL_ALL.ir8_session_start)}} - {{g.toDate(GETTERS_COUNCIL_ALL.ir8_session_end)}}</i> <br>
            </v-col>
          </v-row>
          <v-row v-if="GETTERS_COUNCIL_ALL.is_lab" style="font-size: 14px;">
            <v-col cols="3" class="pa-0">
              <v-icon left>mdi-flask-outline</v-icon>Лаб.приборы
            </v-col>
            <v-col cols="3" class="pa-0">
              {{ GETTERS_COUNCIL_ALL.lab_session_name }}
            </v-col>
            <v-col cols="6" class="pa-0">
              <v-icon left>mdi-calendar</v-icon><i>{{g.toDate(GETTERS_COUNCIL_ALL.lab_session_start)}} - {{g.toDate(GETTERS_COUNCIL_ALL.lab_session_end)}}</i> <br>
            </v-col>
          </v-row>
        </v-container>

      </v-card-title>

      <v-list class="d-flex align-center justify-start" v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-list-item>
              <v-btn
                v-if="(GETTERS_COUNCIL_ALL.status == 0 || GETTERS_COUNCIL_ALL.status == 1) && page_editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="show_add_proposal_modal()">Добавить заявку
              </v-btn>

              <v-btn
                v-if="GETTERS_COUNCIL_ALL.status == 0 && page_editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="council_status_change_dialog = true;">Запланировать
              </v-btn>

              <v-btn
                v-if="GETTERS_COUNCIL_ALL.status == 1 && page_editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="council_status_change_dialog = true;">На очное обсуждение
              </v-btn>

              <v-btn
                v-if="GETTERS_COUNCIL_ALL.status == 2 && page_editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="council_status_change_dialog = true;">На планирование
              </v-btn>

              <v-btn
                v-if="GETTERS_COUNCIL_ALL.status == 5 && page_editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: white; margin-right: 15px;"
                @click="council_status_change_dialog = true;">Завершить
              </v-btn>

              <v-btn
                v-if="GETTERS_COUNCIL_ALL.status < 2 && page_editable.can_edit"
                class="my-2"
                x-small
                :color="$mainColor"
                style="color: red; margin-right: 15px;"
                @click="delete_council_dialog=true">Удалить совет
              </v-btn>


              <v-btn
                v-if="(GETTERS_COUNCIL_ALL.status < 4 || GETTERS_COUNCIL_ALL.status == 5) && GETTERS_COUNCIL_ALL.proposals_council.length > 0 && page_editable.can_export"
                @click="export_pdf()"
                style="margin-right: 15px;"
                x-small>Экспорт заявок в .pdf
              </v-btn>
            </v-list-item>
          </v-col>
          <v-col style="text-align: right;">
            <v-menu
              bottom
              left>
              <template v-slot:activator="{ on }">
                <v-btn class="mr-4" x-small v-on="on">
                  {{"экспорт"}}<v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-if="(GETTERS_COUNCIL_ALL.status == 2 || GETTERS_COUNCIL_ALL.status == 1 || GETTERS_COUNCIL_ALL.status == 5) && GETTERS_COUNCIL_ALL.proposals_council.length > 0  && page_editable.can_edit"
                  class="item-menu-text"
                  x-small
                  @click="export_council_word()"
                >
                  <v-list-item-subtitle>{{ "Экспорт бланка решения" }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item
                  v-if="GETTERS_COUNCIL_ALL.status == 3 && GETTERS_COUNCIL_ALL.proposals_council.length > 0 && page_editable.can_export"
                  @click="export_council_word()"
                  class="item-menu-text"
                  x-small
                >
                  <v-list-item-subtitle>{{ "Экспорт решения" }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item
                  v-if="(GETTERS_COUNCIL_ALL.status < 4  || GETTERS_COUNCIL_ALL.status == 5) && GETTERS_COUNCIL_ALL.proposals_council.length > 0 && page_editable.can_export"
                  @click="export_council_excel()"
                  class="item-menu-text"
                  x-small
                >
                  <v-list-item-subtitle>{{ "Экспорт заявок в excel" }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item
                  v-if="(GETTERS_COUNCIL_ALL.status < 4 || GETTERS_COUNCIL_ALL.status == 5) && GETTERS_COUNCIL_ALL.proposals_council.length > 0 && page_editable.can_export"
                  @click="export_pdf()"
                  class="item-menu-text"
                  x-small
                >
                  <v-list-item-subtitle>{{ "Экспорт заявок в .pdf" }}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item
                  v-if="GETTERS_COUNCIL_ALL.status == 3 && GETTERS_COUNCIL_ALL.proposals_council.length > 0 && page_editable.can_export"
                  @click="export_report()"
                  class="item-menu-text"
                  x-small
                >
                  <v-list-item-subtitle>{{ "Экспорт отчета" }}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-list>

      <div class="d-flex flex-nowrap justify-space-between" v-if="(GETTERS_COUNCIL_ACCESS.is_moderator || GETTERS_COUNCIL_ACCESS.is_expert) && GETTERS_COUNCIL_ALL.status > 0">
        <div style="width:95%;">
          <v-card-text style="margin-left: 15px; padding-bottom: 0px;">
            <v-row>
              <v-card width="100%" style="margin:10px;">
                <v-list subheader>
                  <v-subheader>
                    <v-row>
                      <v-col cols="7" style="margin: auto;">
                        <div class="d-flex flex-nowrap">
                          <v-icon>mdi-account-tie</v-icon>Эксперты
                          <v-tooltip right v-if="(GETTERS_COUNCIL_ALL.status == 1 || GETTERS_COUNCIL_ALL.status == 2) && page_editable.can_edit">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                color="green lighten-1"
                                @click="add_to_team_type = 1; add_to_team_dialog = true;"
                                style="margin-left: 8px !important;">
                                mdi-plus
                                </v-icon>
                            </template>
                            <span>добавить</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                      <v-col cols="5" style="margin: auto;">
                        <div class="d-flex flex-nowrap">
                          <v-icon>mdi-account-group-outline</v-icon>Приглашенные участники
                          <v-tooltip right v-if="(GETTERS_COUNCIL_ALL.status == 1 || GETTERS_COUNCIL_ALL.status == 2) && page_editable.can_edit">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                small
                                v-bind="attrs"
                                v-on="on"
                                color="green lighten-1"
                                @click="add_to_team_type = 0; add_to_team_dialog = true;"
                                style="margin-left: 8px !important;">
                                mdi-plus
                                </v-icon>
                            </template>
                            <span>добавить</span>
                          </v-tooltip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-subheader>
                    <v-row>
                      <v-col cols="7" style="margin: auto;">
                        <v-row v-for="(item, i) in GETTERS_COUNCIL_ALL.council_teams" v-if="item.is_active == true && item.type == 1" :key="i">
                          <v-col cols="7" style="margin: auto;" class="pa-0 d-flex flex-nowrap ">
                              <p class="ml-12">
                                <v-icon>mdi-badge-account-outline</v-icon>
                                {{item.user.individual.last_name}} {{item.user.individual.first_name}} {{item.user.individual.middle_name}}
                              </p>
                              <v-tooltip right v-if="(GETTERS_COUNCIL_ALL.status == 1 || GETTERS_COUNCIL_ALL.status == 2) && page_editable.can_edit">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red lighten-1"
                                    @click="delete_from_team(item)"
                                    style="margin-top: -16px !important; margin-left: 8px !important;">
                                    mdi-delete
                                    </v-icon>
                                </template>
                                <span>удалить</span>
                              </v-tooltip>
                          </v-col>
                          <v-col cols="5" style="margin: auto;"  class="pa-0" v-if="GETTERS_COUNCIL_ALL.status == 2 || GETTERS_COUNCIL_ALL.status == 3">
                            <v-chip :color=expert_res(item,1) text-color="white">
                              <v-icon left>{{expert_res(item,'mdi')}}</v-icon>
                              {{expert_res(item,'text')}}
                            </v-chip>
                            <!-- <div v-if="item.user_id == my_id && GETTERS_COUNCIL_ALL.status == 2"> -->
                              <v-tooltip left v-if="item.user_id == my_id && GETTERS_COUNCIL_ALL.status == 2">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    class="ma-2"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="green lighten-1"
                                    @click="make_my_solution(item, true)">
                                    mdi-check-underline
                                  </v-icon>
                                </template>
                                <span> подтвердить </span>
                              </v-tooltip>
                              <v-tooltip left v-if="item.user_id == my_id && GETTERS_COUNCIL_ALL.status == 2">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    class="ma-2"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="red lighten-1"
                                    @click="make_solution_no_dialog = true, make_solution_no_item = item">
                                    mdi-close
                                  </v-icon>
                                </template>
                                <span> отклонить </span>
                              </v-tooltip>
                              <v-tooltip right v-if="item.approve_type == 1">
                                  <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                      small
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="show_comment(item.comment)">
                                      mdi-comment-text
                                      </v-icon>
                                  </template>
                                  <span>{{ item.comment }}</span>
                              </v-tooltip>




                            <!-- </div> -->

                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="5" style="margin: auto;">
                        <v-row v-for="(item, i) in GETTERS_COUNCIL_ALL.council_teams" v-if="item.is_active == true && item.type == 0" :key="i">
                          <v-col cols="12" style="margin: auto;" class="pa-0 d-flex flex-nowrap ">
                            <p class="ml-12">
                              <v-icon>mdi-badge-account-outline</v-icon>
                              {{item.user.individual.last_name}} {{item.user.individual.first_name}} {{item.user.individual.middle_name}}
                            </p>
                            <v-tooltip right v-if="(GETTERS_COUNCIL_ALL.status == 1 || GETTERS_COUNCIL_ALL.status == 2) && page_editable.can_edit">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  color="red lighten-1"
                                  @click="delete_from_team(item)"
                                  style="margin-top: -16px !important; margin-left: 8px !important;">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>удалить</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>

                </v-list>
              </v-card>
            </v-row>

          </v-card-text>
        </div>
      </div>

      <div class="d-flex flex-nowrap justify-space-between">
          <div style="width:95%;">
            <v-card-text style="margin-bottom: 15px; margin-left: 15px;">

    <!-- PROPOSALS           -->
              <v-row>
                <v-card width="100%" style="margin:10px;">
                  <v-list subheader>
                    <v-subheader>
                      <b>
                        <v-icon>mdi-attachment</v-icon>Заявки
                      </b>
                    </v-subheader>

                    <v-list-item v-if="all_proposals.length === 0">{{$t('ModalCard.absent')}}</v-list-item>

                    <v-card-text v-else>
                      <v-tabs-items>
                        <v-data-table v-if="GETTERS_COUNCIL_ALL.status == 0 && page_editable.can_edit && GETTERS_COUNCIL_ACCESS.is_moderator"
                          :style="{color: $mainColor}"
                          :headers="current_headers"
                          :items="all_proposals"
                          :loading-text="$t('User.loading_orders')"
                          :fixed-header="true"
                          :height="'55vh'"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td>
                                <span @click="open_proposal_card(item.proposal_id)" style="cursor: pointer;">
                                  <b style="color: #9f00ff;">{{ item.proposal_id }}</b><i style="font-style: italic; color: #9f00ff; font-size: 12px;">от {{ item.proposal.date_income }} </i> {{ item.proposal.name }}
                                  <br>
                                  <i style="font-style: italic;">{{ item.proposal.keywords }}</i>
                                </span>
                              </td>
                                {{ item.proposal.stations[0] }}
                              <td v-for="exp in experts">
                                <v-checkbox
                                  :input-value="is_selected_expert(item, exp.profile_id)"
                                  :value="is_selected_expert(item, exp.profile_id)"
                                  style="margin:0px;padding:0px"
                                  color="#535353"
                                  hide-details
                                  @change="checkbox_select_expert(item, exp.profile_id)"
                                >
                                </v-checkbox>
                              </td>
                              <td>
                                <v-tooltip left>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      class="ma-2"
                                      small
                                      v-bind="attrs"
                                      v-on="on"
                                      color="red lighten-1"
                                      @click="delete_proposal_dialog = true, delete_proposal_id = item.proposal_id, delete_proposal_council_id = item.id">
                                      mdi-delete
                                    </v-icon>
                                  </template>
                                  <span> удалить заявку из совета </span>
                                </v-tooltip>
                              </td>
                            </tr>
                          </template>
                        </v-data-table>

                        <v-data-table v-else
                          :style="{color: $mainColor}"
                          :headers="current_headers"
                          :items="filtered_proposals"
                          :loading-text="$t('User.loading_orders')"
                          multi-sort
                        >
                          <template v-slot:top>
                            <v-chip-group
                              v-model="selected_station"
                              active-class="primary--text"
                              column
                            >
                              <v-chip
                                :key=0
                                :value=0
                              >
                                Все
                              </v-chip>
                              <v-chip
                                v-for="station in stations"
                                :key="station.id"
                                :value="station.id"
                              >
                                {{ station.descr }}
                              </v-chip>
                            </v-chip-group>

                            <v-container v-if="selected_station > 0">
                              <v-row>
                                <v-col cols="3" v-if="GETTERS_COUNCIL_ALL.status == 2 || GETTERS_COUNCIL_ALL.status == 3 || GETTERS_COUNCIL_ALL.status == 5">
                                  <v-row>
                                    <v-text-field
                                      v-model="station_time_available"
                                      label="Доступно (ч)"
                                      type="number"
                                      :readonly="GETTERS_COUNCIL_ALL.status != 2 || !GETTERS_COUNCIL_ACCESS.is_moderator"
                                      :error="station_time_provided > station_time_available"
                                      ></v-text-field>

                                    <v-tooltip v-if="GETTERS_COUNCIL_ACCESS.is_moderator && GETTERS_COUNCIL_ALL.status == 2">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                          class="ma-2"
                                          small
                                          v-bind="attrs"
                                          v-on="on"
                                          color="green lighten-1"
                                          @click="save_station_time_available()">
                                          mdi-check-underline
                                        </v-icon>
                                      </template>
                                      <span> сохранить </span>
                                    </v-tooltip>
                                  </v-row>
                                </v-col>

                                <v-col cols="2">
                                  <v-text-field
                                    v-model="station_time_provided"
                                    label="Принято (ч)"
                                    readonly
                                    :error="station_time_provided > station_time_available"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                  <v-text-field
                                    v-model="station_time_undefined"
                                    label="Нет решения (ч)"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                  <v-text-field
                                    v-model="station_time_to_modificate"
                                    label="На доработку (ч)"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="2">
                                  <v-text-field
                                    v-model="station_time_rejected"
                                    label="Отклонено (ч)"
                                    readonly
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </template>

                          <template v-slot:body="{ items, isSelected, select}">
                            <tbody>
                              <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                                <td>
                                    <span @click="open_proposal_card(item.proposal_id)" style="cursor: pointer;">
                                      <b style="color: #9f00ff;">{{ item.proposal_id }}</b><i style="font-style: italic; color: #9f00ff; font-size: 12px;"> от {{ item.proposal.date_income }} </i> {{ item.proposal.name }}
                                      <br>
                                      <i style="font-style: italic;">{{ item.proposal.keywords }}</i>
                                    </span>
                                </td>
                        <!-- station -->
                                <td>
                                  <span>
                                    <p>
                                      {{ item.proposal.stations[0] }}
                                    </p>
                                  </span>
                                </td>
                        <!-- status -->
                                <td v-if="GETTERS_COUNCIL_ALL.status > 1">
                                  <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
                                    <span @click="make_editable_solution(item)" style="cursor: pointer;">
                                      <p>
                                        {{ council_status(item.status) }}
                                      </p>
                                    </span>
                                  </div>
                                  <div v-if="!GETTERS_COUNCIL_ACCESS.is_moderator && GETTERS_COUNCIL_ACCESS.is_expert">
                                    <p>
                                      {{ council_status(item.status) }}
                                    </p>
                                  </div>
                                </td>
                        <!-- duration -->
                                <td v-if="GETTERS_COUNCIL_ALL.status > 1">
                                  <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
                                    <span @click="make_editable_duration(item)" style="cursor: pointer;">
                                      {{ item.proposal.experiment_duration }} / {{ item.provided_experiment_duration ? item.provided_experiment_duration : 'не отпределено' }}
                                    </span>
                                  </div>
                                  <div v-if="!GETTERS_COUNCIL_ACCESS.is_moderator && GETTERS_COUNCIL_ACCESS.is_expert">
                                    {{ item.proposal.experiment_duration }} / {{ item.provided_experiment_duration ? item.provided_experiment_duration : 'не отпределено' }}
                                  </div>
                                </td>
                        <!-- comments -->
                                <td v-if="GETTERS_COUNCIL_ALL.status == 2 || GETTERS_COUNCIL_ALL.status == 4">
                                  <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
                                    <span @click="make_editable_comment(item)" style="cursor: pointer;">
                                      <p v-if="item.comment && item.comment.length > 2">
                                        {{ item.comment }}
                                      </p>
                                      <v-icon v-else
                                            class="ma-2"
                                            small
                                            color="red lighten-1"
                                            @click="make_editable_comment(item)">
                                            mdi-pencil-outline
                                          </v-icon>
                                    </span>
                                  </div>
                                  <div v-if="!GETTERS_COUNCIL_ACCESS.is_moderator && GETTERS_COUNCIL_ACCESS.is_expert">
                                    <p v-if="item.comment && item.comment.length > 2">
                                      {{ item.comment }}
                                    </p>
                                  </div>
                                </td>
                        <!-- proposal_status -->
                                <td v-if="GETTERS_COUNCIL_ALL.status == 3">
                                  <v-chip
                                    x-small
                                    
                                    :color="proposal_status(item)">
                                    {{ g.proposalStatusDescr(item.proposal.last_status_id) }}
                                  </v-chip>
<!-- 
                                  <v-chip
                                    v-if="item.proposal.extension_to"
                                    x-small
                                    color="#1dd5de"
                                  >
                                  {{ g.toDate(item.proposal.extension_to) }}
                                  </v-chip> -->

                                  <v-tooltip left v-if="item.proposal.extension_to">
                                      <template v-slot:activator="{ on, attrs }">

                                        <v-chip
                                          v-if="item.proposal.extension_to"
                                          v-bind="attrs"
                                          v-on="on"
                                          x-small
                                          color="#1dd5de"
                                        >
                                        {{ g.toDate(item.proposal.extension_to) }}
                                        </v-chip>
                                      </template>
                                      <span>заявка продлена до:</span>
                                  </v-tooltip>
                                </td>
                        <!-- calendar -->
                                <td v-if="GETTERS_COUNCIL_ALL.status == 5 || GETTERS_COUNCIL_ALL.status == 3">
                                  <div v-if="item.status == 1">
                                    <v-row v-if="item.comment && item.comment.length > 0">
                                      {{ item.comment }}
                                    </v-row>
                                    <v-row>
                                      <div class="date-interval d-flex align-center justify-space-between" v-for="(jtem, i) in stations[item.proposal.station_id]['full_station_events']" :key="i">
                                        <div v-if="jtem.source.proposal_id == item.proposal_id">
                                          {{formate_datetimeinterval(jtem)}}
                                        </div>
                                      </div>
                                    </v-row>
                                  </div>
                                  <div v-else>
                                    <v-row v-if="item.comment && item.comment.length > 0">
                                      {{ item.comment }}
                                    </v-row>
                                  </div>
                                </td>
                        <!-- mark -->
                                <td v-if="GETTERS_COUNCIL_ALL.status > 0 && GETTERS_COUNCIL_ALL.status != 5 && page_editable.can_edit">
                                  <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
                                    <span @click="make_editable_mark(item)" style="cursor: pointer;">
                                      <b>
                                          {{ item.avarage }}
                                        </b>
                                      <div v-if="item.old_mark >= 0">
                                        <s>
                                          {{ item.old_mark }}
                                        </s>
                                      </div>
                                    </span>
                                  </div>
                                </td>
                        <!-- experts -->
                                <td v-if="GETTERS_COUNCIL_ALL.status > 0 && GETTERS_COUNCIL_ALL.status != 5">
                                  <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
                                    <v-row v-if="page_editable.can_see_experts">
                                        <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                          <v-row>
                                            <v-col cols="8" class="pt-1 pb-0">
                                              <v-badge color="red lighten-2" :content="exp_rec.mark>0 ? exp_rec.mark : '-' " x-small overlap>
                                                <v-chip :color="$mainColor" text-color="white">
                                                  <b>
                                                    <span style="color:white !important;">
                                                      {{ exp_rec.expert.individual.last_name }}
                                                    </span>
                                                  </b>
                                                </v-chip>
                                              </v-badge>
                                            </v-col>
                                            <v-col cols="4" class="pt-1 pb-0">
                                              <v-tooltip left v-if="exp_rec.comment != null && exp_rec.comment.length > 0">
                                                  <template v-slot:activator="{ on, attrs }">
                                                      <v-icon
                                                      small
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      @click="show_comment(exp_rec.comment)">
                                                      mdi-comment-text
                                                      </v-icon>
                                                  </template>
                                                  <span>{{ exp_rec.comment }}</span>
                                              </v-tooltip>
                                              <v-tooltip left v-if="page_editable.can_edit && (GETTERS_COUNCIL_ALL.status == 0 || (GETTERS_COUNCIL_ALL.status == 1 && !exp_rec.mark))">
                                                  <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                      class="ma-2"
                                                      small
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      color="red lighten-1"
                                                      @click="delete_exp(item.id, exp_rec.id)">
                                                      mdi-delete
                                                    </v-icon>
                                                  </template>
                                                  <span>{{ 'удалить эксперта' }} </span>
                                              </v-tooltip>
                                            </v-col>
                                          </v-row>
                                        </div>
                                    </v-row>
                                    <v-row v-else>
                                      <v-col>
                                        <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                          <v-row>
                                            <v-col class="pt-1 pb-0">
                                                <v-chip :color="$mainColor" text-color="white">
                                                  <b>
                                                    <span style="color:white !important;">
                                                      {{ exp_rec.expert.individual.last_name }}
                                                    </span>
                                                  </b>
                                                </v-chip>
                                            </v-col>
                                          </v-row>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <div v-if="!GETTERS_COUNCIL_ACCESS.is_moderator && GETTERS_COUNCIL_ACCESS.is_expert">
                                    <v-row v-if="GETTERS_COUNCIL_ALL.status == 2">
                                        <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                          <v-row>
                                            <v-col cols="8" class="pt-1 pb-0">
                                              <v-badge color="red lighten-2" :content="exp_rec.mark>0 ? exp_rec.mark : '-' " x-small overlap>
                                                <v-chip :color="$mainColor" text-color="white">
                                                  <b>
                                                    <span style="color:white !important;">
                                                      {{ exp_rec.expert.individual.last_name }}
                                                    </span>
                                                  </b>
                                                </v-chip>
                                              </v-badge>
                                            </v-col>
                                            <v-col cols="4" class="pt-1 pb-0">
                                              <v-tooltip left v-if="exp_rec.comment != null && exp_rec.comment.length > 0">
                                                  <template v-slot:activator="{ on, attrs }">
                                                      <v-icon
                                                      small
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      @click="show_comment(exp_rec.comment)">
                                                      mdi-comment-text
                                                      </v-icon>
                                                  </template>
                                                  <span>{{ exp_rec.comment }}</span>
                                              </v-tooltip>
                                            </v-col>
                                          </v-row>
                                        </div>
                                    </v-row>
                                    <v-row v-else>
                                      <v-col>
                                        <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                          <v-row>
                                            <v-col class="pt-1 pb-0">
                                                <v-chip :color="$mainColor" text-color="white">
                                                  <b>
                                                    <span style="color:white !important;">
                                                      {{ exp_rec.expert.individual.last_name }}
                                                    </span>
                                                  </b>
                                                </v-chip>
                                            </v-col>
                                          </v-row>
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </td>
                          <!-- actions -->
                                <td v-if="page_editable.can_edit && GETTERS_COUNCIL_ALL.status == 1">
                                  <v-tooltip left  v-if="GETTERS_COUNCIL_ACCESS.is_moderator">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        class="ma-2"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        color="green lighten-1"
                                        @click="add_expert(item.id)">
                                        mdi-plus-circle-outline
                                      </v-icon>
                                    </template>
                                    <span> добавить эксперта </span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </tbody>
                          </template>

<!--
                          <template v-slot:item.proposal_id="{ item }" class="pa-0" >
                              <span @click="open_proposal_card(item.proposal_id)" style="cursor: pointer;">
                                <b>{{ item.proposal_id }}</b> {{ item.proposal.name }} <i style="font-style: italic; color: #9f00ff; font-size: 12px;">от {{ item.proposal.date_income }} </i>
                                <br>
                                <i style="font-style: italic;">{{ item.proposal.keywords }}</i>
                              </span>
                          </template>
                          <template v-slot:item.stations="{ item }">
                              {{ item.proposal.stations[0] }}
                          </template>
                          <template v-slot:item.status="{ item }" v-if="GETTERS_COUNCIL_ALL.status >= 2">
                            <span @click="make_editable_solution(item)" style="cursor: pointer;">
                              <p>
                                {{ council_status(item.status) }}
                              </p>
                            </span>
                          </template>
                          <template v-slot:item.provided_experiment_duration="{ item }" v-if="GETTERS_COUNCIL_ALL.status >= 2">
                            <span @click="make_editable_duration(item)" style="cursor: pointer;">
                              {{ item.proposal.experiment_duration }} / {{ item.provided_experiment_duration ? item.provided_experiment_duration : 'не отпределено' }}
                            </span>
                          </template>
                          <template v-slot:item.comment="{ item }">
                            <span @click="make_editable_comment(item)" style="cursor: pointer;">
                              <p v-if="item.comment && item.comment.length > 2">
                                {{ item.comment }}
                              </p>
                              <v-icon v-else
                                    class="ma-2"
                                    small
                                    color="red lighten-1"
                                    @click="make_editable_comment(item)">
                                    mdi-pencil-outline
                                  </v-icon>

                            </span>
                          </template>
                          <template v-slot:item.avarage="{ item }" v-if="GETTERS_COUNCIL_ALL.status >= 1 && page_editable.can_edit">
                            <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator && !GETTERS_COUNCIL_ACCESS.is_expert">
                              <span @click="make_editable_mark(item)" style="cursor: pointer;">

                              <b>
                                  {{ item.avarage }}
                                </b>
                              <div v-if="item.old_mark >= 0">
                                <s>
                                  {{ item.old_mark }}
                                </s>
                              </div>
                              </span>
                            </div>
                          </template>
                          <template v-slot:item.experts="{ item }" v-if="GETTERS_COUNCIL_ALL.status >= 1">
                            <div v-if="GETTERS_COUNCIL_ACCESS.is_moderator && !GETTERS_COUNCIL_ACCESS.is_expert">
                              <v-row v-if="page_editable.can_see_experts">
                                  <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                    <v-row>
                                      <v-col cols="8" class="pt-1 pb-0">
                                        <v-badge color="red lighten-2" :content="exp_rec.mark>0 ? exp_rec.mark : '-' " x-small overlap>
                                          <v-chip :color="$mainColor" text-color="white">
                                            <b>
                                              <span style="color:white !important;">
                                                {{ exp_rec.expert.individual.last_name }}
                                              </span>
                                            </b>
                                          </v-chip>
                                        </v-badge>
                                      </v-col>
                                      <v-col cols="4" class="pt-1 pb-0">
                                        <v-tooltip left v-if="exp_rec.comment != null && exp_rec.comment.length > 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="show_comment(exp_rec.comment)">
                                                mdi-comment-text
                                                </v-icon>
                                            </template>
                                            <span>{{ exp_rec.comment }}</span>
                                        </v-tooltip>
                                        <v-tooltip left v-if="page_editable.can_edit && (GETTERS_COUNCIL_ALL.status == 0 || (GETTERS_COUNCIL_ALL.status == 1 && !exp_rec.mark))">
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon
                                                class="ma-2"
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                color="red lighten-1"
                                                @click="delete_exp(item.id, exp_rec.id)">
                                                mdi-delete
                                              </v-icon>
                                            </template>
                                            <span>{{ 'удалить эксперта' }} </span>
                                        </v-tooltip>
                                      </v-col>
                                    </v-row>
                                  </div>
                              </v-row>
                              <v-row v-else>
                                <v-col>
                                  <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                    <v-row>
                                      <v-col class="pt-1 pb-0">
                                          <v-chip :color="$mainColor" text-color="white">
                                            <b>
                                              <span style="color:white !important;">
                                                {{ exp_rec.expert.individual.last_name }}
                                              </span>
                                            </b>
                                          </v-chip>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                            <div v-if="GETTERS_COUNCIL_ACCESS.is_expert">
                              <v-row v-if="GETTERS_COUNCIL_ALL.status == 2">
                                  <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                    <v-row>
                                      <v-col cols="8" class="pt-1 pb-0">
                                        <v-badge color="red lighten-2" :content="exp_rec.mark>0 ? exp_rec.mark : '-' " x-small overlap>
                                          <v-chip :color="$mainColor" text-color="white">
                                            <b>
                                              <span style="color:white !important;">
                                                {{ exp_rec.expert.individual.last_name }}
                                              </span>
                                            </b>
                                          </v-chip>
                                        </v-badge>
                                      </v-col>
                                      <v-col cols="4" class="pt-1 pb-0">
                                        <v-tooltip left v-if="exp_rec.comment != null && exp_rec.comment.length > 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                small
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="show_comment(exp_rec.comment)">
                                                mdi-comment-text
                                                </v-icon>
                                            </template>
                                            <span>{{ exp_rec.comment }}</span>
                                        </v-tooltip>
                                      </v-col>
                                    </v-row>
                                  </div>
                              </v-row>
                              <v-row v-else>
                                <v-col>
                                  <div v-for="(exp_rec, exp_index) in item.proposal.proposals_expertise" v-if="exp_rec.council_id == GETTERS_COUNCIL_ALL.id">
                                    <v-row>
                                      <v-col class="pt-1 pb-0">
                                          <v-chip :color="$mainColor" text-color="white">
                                            <b>
                                              <span style="color:white !important;">
                                                {{ exp_rec.expert.individual.last_name }}
                                              </span>
                                            </b>
                                          </v-chip>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </v-col>
                              </v-row>
                            </div>
                          </template>

                          <template v-slot:item.calendars="{ item }" v-if="GETTERS_COUNCIL_ALL.status == 5 || GETTERS_COUNCIL_ALL.status == 3">
                            <div v-if="item.status == 1">
                              <v-row v-if="item.comment && item.comment.length > 0">
                                {{ item.comment }}
                              </v-row>
                              <v-row>
                                <div class="date-interval d-flex align-center justify-space-between" v-for="(jtem, i) in stations[item.proposal.station_id]['full_station_events']" :key="i">
                                  <div v-if="jtem.source.proposal_id == item.proposal_id">
                                    {{formate_datetimeinterval(jtem)}}
                                  </div>
                                </div>
                              </v-row>
                            </div>
                            <div v-else>
                              <v-row v-if="item.comment && item.comment.length > 0">
                                {{ item.comment }}
                              </v-row>
                            </div>
                          </template>

                          <template v-slot:item.actions="{ item }"  v-if="page_editable.can_edit && GETTERS_COUNCIL_ACCESS.is_moderator">
                            <v-tooltip left v-if="GETTERS_COUNCIL_ALL.status == 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    class="ma-2"
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    color="green lighten-1"
                                    @click="add_expert(item.id)">
                                    mdi-plus-circle-outline
                                  </v-icon>
                                </template>
                                <span> добавить эксперта </span>
                            </v-tooltip>
                          </template> -->
                        </v-data-table>
                      </v-tabs-items>
                    </v-card-text>

                  </v-list>
                </v-card>
              </v-row>

          </v-card-text>
        </div>

      </div>

    </v-card>

    <v-dialog v-model="make_solution_no_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">Причина отклонения
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="make_solution_no_dialog_comment"
            outlined
            required
            name="input-7-4"
            :label="$t('comment')"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="make_solution_no_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="make_my_solution(make_solution_no_item, false)">{{"сохранить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="show_comment_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Комментарий эксперта
        </v-card-title>
        <v-card-text>{{ show_comment_dialog_text }}
        </v-card-text>


        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="show_comment_dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mark_change_dialog" width="400px">
      <v-card>
        <v-card-title class="headline">Изменить итоговую оценку
        </v-card-title>

        <v-card-text>
          <v-row class="mt-6">
            <v-col cols="2" class="pt-0 pb-0">
              <v-badge
                overlap
              >
              <template v-slot:badge>
                <p class="white--text" style="font-size: 10px; margin-top: -8px !important;">tot.: </p>
              </template>

              <v-avatar
                :color="slider_color(new_mark)"
                size="30"
              >
                <span class="white--text text-h5">{{ new_mark }}</span>
              </v-avatar>
              </v-badge>
            </v-col>

            <v-col cols="10" class="pt-0 pb-0">
              <v-slider
                v-model="new_mark"
                :thumb-color="slider_color(new_mark)"
                thumb-label="always"
                :thumb-size="20"
                step="0.1"
                min="0"
                max="5"
              >
              </v-slider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="mark_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="save_correct_mark()">{{"сохранить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="solution_change_dialog" width="400px">
      <v-card>
        <v-card-title class="headline">Изменить решение
        </v-card-title>

        <v-card-text>
          <v-btn-toggle
            v-model="new_solution"
            rounded
            small
          >
            <v-btn small value="1">
              Принять
            </v-btn>
            <v-btn small  value="2">
              Отклонить
            </v-btn>
            <!-- <v-btn  x-small value="3">
              Отправить на доработку
            </v-btn> -->
            <v-btn small value="4">
              Отложить
            </v-btn>
          </v-btn-toggle>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="solution_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <!-- <v-btn color="green darken-1" text
            @click="save_correct_solution()">{{"сохранить"}}
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="comment_change_dialog" width="500px">
      <v-card>
        <v-card-title class="headline">Изменить комментарий
        </v-card-title>

        <v-card-text>
          <div v-if="changable_solution == 2" class="input-container input-name modal-mul-select">
            <v-select
              v-model="is_modal_reason"
              :items="reasonsList"
              item-text="name"
              item-value="name"
              outlined
              chips
              required
              multiple
            ></v-select>
          </div>

          <v-card-text>
            <v-textarea
              v-model="new_comment"
              outlined
              required
              name="input-7-4"
              :label="$t('comment')"
            ></v-textarea>
          </v-card-text>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="comment_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="save_correct_comment()">{{"сохранить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="duration_change_dialog" width="450px">
      <v-card>
        <v-card-title class="headline">Изменить предоставленное пучковое время
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="3" class="pt-8">
              <s>
                {{ old_duration }}
              </s>
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="new_duration"
                outlined
                required
                name="input-7-4"
                suffix="часов"
                type="number"
                :label="$t('ModalCard.provided_experiment_duration')"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="duration_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="save_correct_duration()">{{"сохранить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_proposal_dialog" max-width="60%">
      <v-card>
        <v-card-title class="headline">Добавить заявку в совет
        </v-card-title>
        <v-card-text>{{ 'Выберите одну или несколько заявок для добавления в текущий экспертный совет.' }}</v-card-text>
        <v-card-text>{{ '(Назначить экспертов можно будет позднее)' }}</v-card-text>

        <v-row align="center" class="ma-2">
          <v-col cols="12">
            <v-select
                v-model="add_proposal_list"
                :items="availiable_proposals"
                item-text="name"
                item-value="id"
                outlined
                chips
                required
                multiple
            ></v-select>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="add_proposal_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="add_proposal()">{{"Добавить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_proposal_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Удалить заявку из экспертного совета
        </v-card-title>
        <v-card-text>вы уверены что хотите удалить заявку № {{ delete_proposal_id }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="delete_proposal_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="red darken-1" text
            @click="delete_proposal()">{{"Удалить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_council_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Удалить совет
        </v-card-title>
        <v-card-text>вы уверены что хотите удалить совет № {{ GETTERS_COUNCIL_ALL.id }} '{{ GETTERS_COUNCIL_ALL.name }}'</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="delete_council_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="red darken-1" text
            @click="delete_council()">{{"Удалить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="council_status_change_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Изменить статус совета
        </v-card-title>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 0">Вы уверены, что хотите запланировать совет № {{ GETTERS_COUNCIL_ALL.id }} '{{ GETTERS_COUNCIL_ALL.name }}'</v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 1">Вы уверены, что хотите закрыть возможность оценки заявок экспертами и перевести совет № {{ GETTERS_COUNCIL_ALL.id }} '{{ GETTERS_COUNCIL_ALL.name }}' на очное обсуждение</v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 2 && count_no_experts_resolution > 0">
          <p style="color: #e86231; font-size: 18px;" class="ml-6">Не все эксперты подтвердили протокол! </p>
        </v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 2">Вы уверены, что хотите завершить очную часть совета ID={{ GETTERS_COUNCIL_ALL.id }} '{{ GETTERS_COUNCIL_ALL.name }}'</v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 5">Вы уверены, что хотите завершить совет ID={{ GETTERS_COUNCIL_ALL.id }} '{{ GETTERS_COUNCIL_ALL.name }}'</v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 0">После выполнения этого действия:
          <ul>
            <li>Назначенные эксперты получат уведомления и возможность оценить заявки</li>
          </ul>
        </v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 2">После выполнения этого действия:
          <ul>
            <li>Внесенные отрицательные решения("отклонены" и "на доработку") будут применены к заявкам</li>
            <li>Изменение решений будет невозможно</li>
            <li>Заявители отклоненных заявок получат уведомления о изменении статуса</li>
            <li>Ответственные по станциям получат уведомление о необходимости распределить время на следующую сессию</li>
          </ul>
        </v-card-text>
        <v-card-text v-if="GETTERS_COUNCIL_ALL.status == 5">После выполнения этого действия:
          <ul>
            <li>Внесенные решения будут применены к заявкам</li>
            <li>Изменение решений будет невозможно</li>
            <li>Заявители получат уведомления о изменении статуса их заявок и назначенном времени</li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="council_status_change_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="change_council_status()">Подтвердить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_expert_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">Выберите экспертов для заявки
        </v-card-title>
        <v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-combobox
            v-model="selected_new_experts"
            :items="GETTERS_EXPER"
            style="min-width:250px;"
            item-value="id"
            label="Эксперты"
            hint="можно указать одного или несколько экспертов"
            small-chips
            :multiple=true
            single-line>
            <template v-slot:selection="{ attrs, item, selected }">
              <v-chip
                v-if="item === Object(item)"
                v-bind="attrs"
                color="#15336d"
                :input-value="selected"
                dark
                label
                small>
                <span class="pr-2">
                    {{ item.last_name }} {{ item.first_name }}
                </span>
              </v-chip>
            </template>
            <template v-slot:item="{ item }">
              {{ item.last_name }} {{ item.first_name }}
            </template>
          </v-combobox>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red lighten-2" text @click="add_expert_dialog = false">{{ $t('cancel') }}
          </v-btn>
          <v-btn v-if="selected_new_experts !== null" color="green darken-1" text
              @click="add_new_experts()">
              добавить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_to_team_dialog" max-width="40%">
      <v-card>
        <v-card-title class="headline">Добавить участника
        </v-card-title>

        <v-card-text v-if="add_to_team_type == 0">
          <div class="input-container__search-user">
            <v-text-field
              v-model.trim="search_email"
              outlined
              :placeholder="$t('Step5.email_or_surname')"
              @keyup.enter="searchUser()"
              :loading="loadingTeamUser"
              type="text"
              counter="50"
              maxLength="50"
            >
            <template v-slot:append-outer>
              <v-icon @click="searchUser()" :color="$mainColor">mdi-plus-circle</v-icon>
            </template>
            </v-text-field>
          </div>
          <v-list style="width:100%;">
                  <v-list-item-content>
                    <v-list-item-title v-for="(item, i) in added_team" :key="i">
                      {{item.individual.last_name}} {{item.individual.first_name}}
                      <v-icon @click="deleteUserTeam(item)">mdi-close</v-icon>
                    </v-list-item-title>
                  </v-list-item-content>
          </v-list>
        </v-card-text>

        <v-card-text v-if="add_to_team_type == 1">
          <v-combobox
            v-model="selected_new_experts"
            :items="GETTERS_EXPER"
            style="min-width:250px;"
            item-value="id"
            label="Эксперты"
            hint="можно указать одного или несколько экспертов"
            small-chips
            :multiple=true
            single-line>
            <template v-slot:selection="{ attrs, item, selected }">
              <v-chip
                v-if="item === Object(item)"
                v-bind="attrs"
                color="#15336d"
                :input-value="selected"
                dark
                label
                small>
                <span class="pr-2">
                    {{ item.last_name }} {{ item.first_name }}
                </span>
              </v-chip>
            </template>
            <template v-slot:item="{ item }">
              {{ item.last_name }} {{ item.first_name }}
            </template>
          </v-combobox>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="add_to_team_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="add_to_team()">{{"Добавить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="30%" v-model="dialogAddTeamFamily">
      <v-card>
        <v-card-title>Выберите участника</v-card-title>
        <v-card-text>
          <v-select
          :items="individual"
          item-text="name"
          item-value="id"
          placeholder="Выберите участника из результата поиска"
          v-model="individualTeam"
          ></v-select>
          <v-btn
           outlined
           color="error"
           class="ma-2"
           @click="dialogAddTeamFamily = false">{{$t('cancel')}}</v-btn>
          <v-btn
            :color="$mainColor"
            class="ma-2"
            style="color: white;"
           @click="selectSearchUser(individualTeam)">{{$t('ok')}}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "councilModalCard",
  components: {
  },
  props: {
    page_editable: [Array, Object],
    comment: String,
  },
  data() {
    return {
      make_solution_no_dialog_comment: '',
      make_solution_no_dialog: false,
      make_solution_no_item: 0,

      current_headers: [],

      modal_loaded: false,
      experiment_duration: '',
      reasonsList: [
        {id: 1, name : 'Не раскрыто научное содержание'},
        {id: 2, name : 'Не указана новизна'},
        {id: 3, name : 'По формальному признаку. Некорректно заполнены поля заявки'},
        {id: 4, name : 'Низкая научная значимость'},
        {id: 5, name : 'Отсутствует описание/характеристики образца'},
        {id: 6, name : 'Не обоснован выбор метода исследования'},
        {id: 7, name : 'Не представлен план эксперимента'}
      ],
      reasons: null,
      search_email: '',
      loadingTeamUser: false,
      added_team: [],
      individual: [],
      dialogAddTeamFamily: false,
      individualTeam: '',

      show_comment_dialog: false,
      show_comment_dialog_text: '',
      add_proposal_dialog: false,
      add_proposal_list: [],
      availiable_proposals: [],
      delete_proposal_dialog: false,
      delete_proposal_id: null,
      delete_proposal_council_id: null,

      add_expert_dialog: false,
      selected_new_experts: '',
      current_proposal_council_id: null,
      delete_council_dialog: false,

      is_modal_reason: null,
      council_status_change_dialog: false,
      expert_cnt: 0,
      experts: {},

      start_time: null,
      menu_time: false,
      edit_time_mode: false,

      my_id: -1,
      add_to_team_type: 0,
      add_to_team_dialog: false,

      stations: {},
      selected_station: 0,
      all_proposals: [],
      filtered_proposals: [],
      station_time_provided: 0,
      station_time_undefined: 0,
      station_time_rejected: 0,
      station_time_to_modificate: 0,
      new_mark: 0,
      new_solution: 0,
      new_duration: 0,
      new_comment: '',
      changable_id: null,
      changable_solution: 0,
      mark_change_dialog: false,
      duration_change_dialog: false,
      solution_change_dialog: false,
      comment_change_dialog: false,
      station_time_available: 0,
      council_station_id: null,
      old_duration: 0,

      call_id: null,
    };
  },
  beforeMount() {
    this.my_id = localStorage.isLoggedIn
    // this.start_time = this.GETTERS_COUNCIL_ALL.start_time ? `${this.GETTERS_COUNCIL_ALL.start_time}` : `00:00`
    this.start_time = this.GETTERS_COUNCIL_ALL.start_time.substring(0,5)
    this.reload_headers();

    this.filtered_proposals = this.all_proposals = this.calc_all_avarage(this.GETTERS_COUNCIL_ALL.proposals_council)
    this.recalcStations();
  },

  computed: {
    ...mapGetters([
      'GETTERS_COUNCIL_ALL',
      'GETTERS_COUNCIL_ACCESS',
      'GETTERS_EXPER',
      'GETTERS_INDIVIDUAL',
      'GETTERS_STATION_CALENDAR',
      'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
      'GETTERS_NEED_RELOAD_CALENDAR',
    ]),

    count_no_experts_resolution(){
      var cnt = 0
      this.GETTERS_COUNCIL_ALL.council_teams.forEach(item => {
        if(item.approve_type != 2)
          cnt = cnt + 1;
      })
      return cnt
    },

  },

  methods:  {
    ...mapActions([
      'CHANGE_COUNCIL_PROPOSALS',
      'GET_URL_PRD',
      'GET_AVAILABLE_COUNCIL_PROPOSALS',
      'GET_COUNCIL_ALL',
      'CHANGE_COUNCIL_PROPOSAL_EXPERTS',
      'CHANGE_COUNCIL_PROPOSAL_SOLUTION',
      'NEXT_COUNCIL_STATUS',
      'UPLOAD_LIST_TO_EXCEL',
      'UPLOAD_COUNCIL_TO_DOCX',
      'UPDATE_COUNCIL_TIME',
      'UPDATE_EXPERT_COUNCIL_RESOLUTION',
      'GET_TEAM_INDIVIDUAL',
      'CHANGE_COUNCIL_TEAM',
      'GET_CALENDAR_LIST',
      'SAVE_STATION_TIME_AVAILABLE',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
      'SHOW_PROPOSAL_CARD',
    ]),

    allowedStep: m => m % 30 === 0,

    proposal_status(item){
      if(item.proposal.last_status_id == 8 || item.proposal.last_status_id == 10 || item.proposal.last_status_id == 9)
        return '#00cf06'
      else if(item.proposal.last_status_id == 7)
        return '#cfcc00'
      else
        return '#d9c3b1'
    },

    slider_color(val){
      if(val < 2.6)
        return '#a63a0d'
      else if(val > 4)
        return '#0da635'
      else
        return '#a69d0d'
    },

    save_station_time_available(){
      this.UPDATE_OVERLAY(true)
      var args = {
        station_id: this.selected_station,
        new_time_available: this.station_time_available,
        council_station_id: this.council_station_id,
        council_id: this.GETTERS_COUNCIL_ALL.id,
      }
      this.SAVE_STATION_TIME_AVAILABLE(args)
        .then(res => {
          this.UPDATE_OVERLAY(false)
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
        })

    },

    make_my_solution(item, res){
      var args = {
          councilteam_id: item.id,
          resolution: res,
        }
        if(!res){
          args.comment = this.make_solution_no_dialog_comment
        }

        this.UPDATE_OVERLAY(true)

        this.UPDATE_EXPERT_COUNCIL_RESOLUTION(args)
        .then(res => {
          this.make_solution_no_dialog = false
          this.reload_council()
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
        })
    },

    expert_res(exp, type) {
      if(type == 'mdi'){
        if(exp.approve_type == 0)
          return 'mdi-help-circle-outline'
        else if(exp.approve_type == 2)
          return 'mdi-check-circle-outline'
        else
          return 'mdi-close-circle-outline'
      }
      else if(type == 1){
        if(exp.approve_type == 0)
          return '#bbbbbb'
        else if(exp.approve_type == 2)
          return '#75c210'
        else
          return '#e00505'
      }
      else{
        if(exp.approve_type == 0)
          return 'нет решения'
        else if(exp.approve_type == 2)
          return 'подтвердил'
        else
          return 'отклонил'
      }
    },

    open_proposal_card(id) {
      this.call_id = new Date()
      this.SHOW_PROPOSAL_CARD({
        'proposal_id' : id,
        'call_id': this.call_id
      })
    },

    delete_from_team(item){
      this.UPDATE_OVERLAY(true)
      this.CHANGE_COUNCIL_TEAM({
        'type': 'delete',
        'council_id': this.GETTERS_COUNCIL_ALL.id,
        'users': {council_team_id: item.id},
      })
      .then(res => {
        if(res.status){
          this.add_to_team_dialog = false
          this.reload_council()
        }
        else{
          this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        }
      })
    },

    add_to_team(){
      var new_users = []
      if(this.add_to_team_type == 0){
        this.added_team.forEach(item => {
          new_users.push({
            user_id: item.id,
            type: this.add_to_team_type
          })
        })
      }
      else if(this.add_to_team_type == 1){
        this.selected_new_experts.forEach(item => {
          new_users.push({
            user_id: item.profile_id,
            type: this.add_to_team_type
          })
        })
      }

      if (new_users.length == 0) {
        this.$messageHelper(`Выберите участника`, 'error', 5000)
      }
      else{
        this.UPDATE_OVERLAY(true)
        this.CHANGE_COUNCIL_TEAM({
          'type': 'add',
          'council_id': this.GETTERS_COUNCIL_ALL.id,
          'users': new_users,
        })
        .then(res => {
          this.selected_new_experts = null
          if(res.status){
            this.add_to_team_dialog = false
            this.reload_council()

          }
          else{
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
          }
        })

      }
    },

    reload_council(){
      this.GET_COUNCIL_ALL(this.GETTERS_COUNCIL_ALL.id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
    },

    async searchUser() {
      this.loadingTeamUser = true

        this.individual = []
        this.GET_TEAM_INDIVIDUAL(this.search_email)
        .then(res => {
          this.loadingTeamUser = false
          if (res.length === 0) {
            this.$messageHelper(this.$t('Step5.not_user'), 'default')
          }
          else
            this.dialogAddTeamFamily = true
        })
        .catch(e => {
          this.loadingTeamUser = false
          if (typeof e.response.data === 'object') this.$messageHelper(e.response.data.message, 'default');
          else this.$messageHelper(this.$t('unknown_error'), 'default');
        })
    },

    selectSearchUser(selected_user_id) {
      var is_added = false
      if (this.added_team.length !== 0) {
        this.added_team.forEach(item => {
          if (item.id == selected_user_id) {
            this.$messageHelper(this.$t('Step5.member_name__already_been_added'), 'error', 5000)
            is_added = true
          }
        })
      }

      if(!is_added){
        this.GETTERS_INDIVIDUAL.forEach(item => {
          if(item.profile_id == selected_user_id){
            this.added_team.push({
              id: selected_user_id,
              individual: {
                last_name: item.last_name,
                first_name: item.first_name,
                middle_name: item.middle_name
              }
            })
          }
        })
      }

      this.email = ''
      this.dialogAddTeamFamily = false
    },

    deleteUserTeam(id) {
      this.added_team = this.added_team.filter(item => item.id !== id.id)
    },

    updateCouncilTime(){
        var args = {
          council_id: this.GETTERS_COUNCIL_ALL.id,
          start_time: this.start_time ? `${this.start_time}` : `12:00`,
        }
        this.modal_loaded = true

        this.UPDATE_OVERLAY(true)
        this.UPDATE_COUNCIL_TIME(args)
        .then(res => {
            this.modal_loaded = false
            this.edit_time_mode = false
            this.reload_council()
        })
        .catch(() => {
            this.modal_loaded = false
        })
    },

    reload_headers(){
      this.page_editable.can_see_experts = this.page_editable.can_edit || this.GETTERS_COUNCIL_ALL.status == 3

      if(this.GETTERS_COUNCIL_ALL.status == 0 && this.page_editable.can_edit){
        var t = [
          { text: 'Заявка', sortable: true, value: 'proposal_id', width: '250px'},
          { text: 'Станция', sortable: true, value: 'stations'},
        ]
        this.expert_cnt = 0
        this.experts = {}
        this.GETTERS_EXPER.forEach(item => {
          this.expert_cnt = this.expert_cnt + 1
          this.experts[this.expert_cnt] = item
          t.push({text: item.last_name, sortable: false, value: 'experts_'+item.profile_id, width: '18px', class: 'vertical-header-cell', cellClass: 'vertical-header-cell'})
        })
        this.current_headers = t
      }
      else if(this.GETTERS_COUNCIL_ALL.status == 1){
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Станция', sortable: true, value: 'stations'},
       ]
      }
      else if(this.GETTERS_COUNCIL_ALL.status == 3){
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Станция', sortable: true, value: 'stations'},
          { text: 'Решение', sortable: true, value: 'status'},
          { text: 'Пучковое время (ч)', sortable: true, value: 'provided_experiment_duration'},
          { text: 'Статус заявки', sortable: true, value: 'proposal_status'},
          { text: 'Календарь', sortable: false, value: 'calendars', width: '300px'},
        ]
      }
      else if(this.GETTERS_COUNCIL_ALL.status == 5){
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Станция', sortable: true, value: 'stations'},
          { text: 'Решение', sortable: true, value: 'status'},
          { text: 'Пучковое время (ч)', sortable: true, value: 'provided_experiment_duration'},
          { text: 'Календарь', sortable: false, value: 'calendars', width: '300px'},
        ]
      }
      else{
        this.current_headers = [
          { text: 'Заявка', sortable: true, value: 'proposal_id'},
          { text: 'Станция', sortable: true, value: 'stations'},
          { text: 'Решение', sortable: true, value: 'status'},
          { text: 'Пучковое время (ч)', sortable: true, value: 'provided_experiment_duration'},
          { text: 'Комментарий', sortable: false, value: 'comment'},
        ]
      }
      if(this.GETTERS_COUNCIL_ALL.status > 0 && this.GETTERS_COUNCIL_ALL.status != 5){
        if(this.page_editable.can_edit)
          this.current_headers.push({text: '', sortable: true, value: 'avarage', width: '30px'})

        this.current_headers.push({text: 'Эксперты', sortable: false, value: 'experts', width: '250px'})
      }

      if(this.page_editable.can_edit && this.GETTERS_COUNCIL_ALL.status == 1)
         this.current_headers.push({ text: this.$t('actions'), value: 'actions', sortable: false})
    },

    checkbox_select_expert(item, exp_id){
      var found = 0
      item.proposal.proposals_expertise.forEach(jtem => {
        if (jtem.expert.id == exp_id && jtem.council_id == this.GETTERS_COUNCIL_ALL.id){
          found = jtem.id
        }
      })
      if(found > 0){
        this.delete_exp(item.id, found)
      }
      else{
        this.add_new_expert(item.id, exp_id)
      }
    },

    is_selected_expert(item, col){
      var found = false
      item.proposal.proposals_expertise.forEach(jtem => {
        if (jtem.expert.id == col && jtem.council_id == this.GETTERS_COUNCIL_ALL.id){
          found = true
        }
      })
      return found
    },

    show_add_proposal_modal(){
      this.add_proposal_list = []
      this.availiable_proposals = []
      var mst = '', push = false
      this.GET_AVAILABLE_COUNCIL_PROPOSALS()
      .then((res) => {
        res.forEach(item => {
          if (item.council_count == 0) {
            push = false
            if(item.megascience_type_ext_id == 1 && this.GETTERS_COUNCIL_ALL.is_si){
              mst = 'КИСИ'
              push = true
            }
            else if(item.megascience_type_ext_id == 2 && this.GETTERS_COUNCIL_ALL.is_ir8){
              push = true
              mst = 'ИР-8'
            }
            else if(item.megascience_type_ext_id == 3 && this.GETTERS_COUNCIL_ALL.is_lab){
              push = true
              mst = 'LAB'
            }
            else{
            }
            if(push){
              this.availiable_proposals.push({
                id: item.id,
                name: '№' + item.id + ' – ' + mst + ' ' + item.station_name + ': ' + (item.name ? item.name: this.$t('untitled')) })
            }
          }
        })

        this.add_proposal_dialog = true
      })
    },

    add_proposal(){
      if (this.add_proposal_list.length == 0) {
        this.$messageHelper(`Выберите заявки`, 'error', 5000)
      }
      else{
        this.UPDATE_OVERLAY(true)
        this.CHANGE_COUNCIL_PROPOSALS({
          'type': 'add',
          'council_id': this.GETTERS_COUNCIL_ALL.id,
          'proposal_ids': this.add_proposal_list
        })
        .then(res => {
          if(res.status){
            this.$messageHelper(`Заявки добавлены`, 'success', 5000)
            this.add_proposal_dialog = false
            this.$emit('updateParent', {item: -1, close_modal: false})
            this.reload_council()

          }
          else{
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
          }
        })

      }
    },

    show_comment(text){
      this.show_comment_dialog_text = text
      this.show_comment_dialog = true
    },

    delete_proposal(){
      this.UPDATE_OVERLAY(true)
      this.CHANGE_COUNCIL_PROPOSALS({
        'type': 'delete',
        'proposal_council_id': this.delete_proposal_council_id,
        'council_id': this.GETTERS_COUNCIL_ALL.id,
      })
      .then(res => {
        if(res.status){
          this.$messageHelper(`Заявка удалена`, 'success', 5000)
          this.$emit('updateParent', {item: -1, close_modal: false})
          this.reload_council()
          this.delete_proposal_dialog = false
        }
        else{
          this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        }
      })
    },

    delete_council(){
      this.$emit('deleteCouncil',{item: this.GETTERS_COUNCIL_ALL.id})
    },

    delete_exp(proposal_council_id, id){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_COUNCIL_PROPOSAL_EXPERTS({
        'type': 'delete',
        'proposal_council_id': proposal_council_id,
        'proposal_expert_id': id
      })
      .then(res => {
        if(res.status){
          this.$messageHelper(`Эксперт удален`, 'success', 5000)
          this.add_expert_dialog = false
          this.$emit('updateParent', {item: -1, close_modal: false})
          this.reload_council()

        }
        else{
          this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        }
      })

    },

    add_expert(id){
      this.current_proposal_council_id = id
      this.selected_new_experts = null
      this.add_expert_dialog = true
    },

    add_new_expert(proposal_council_id, new_experts_id){
      this.CHANGE_COUNCIL_PROPOSAL_EXPERTS({
          'type': 'add',
          'proposal_council_id': proposal_council_id,
          'expert_ids': [new_experts_id]
        })
        .then(res => {
          if(res.status){
            this.$messageHelper(`Эксперты добавлены`, 'success', 5000)
            this.$emit('updateParent', {item: -1, close_modal: false})
            this.reload_council()
          }
          else{
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
          }
        })
    },

    add_new_experts(){
      if (this.selected_new_experts.length == 0) {
        this.$messageHelper(`Выберите ответственного`, 'error', 5000)
      }
      else{
        this.UPDATE_OVERLAY(true)

        let new_experts_ids = [];
        this.selected_new_experts.forEach((item, i) => {
          new_experts_ids.push(item.profile_id)
        });

        this.CHANGE_COUNCIL_PROPOSAL_EXPERTS({
          'type': 'add',
          'proposal_council_id': this.current_proposal_council_id,
          'expert_ids': new_experts_ids
        })
        .then(res => {
          if(res.status){
            this.$messageHelper(`Эксперты добавлены`, 'success', 5000)
            this.add_expert_dialog = false
            this.$emit('updateParent', {item: -1, close_modal: false})
            this.reload_council()

          }
          else{
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
          }
        })
      }
    },

    change_council_status(id){
      this.UPDATE_OVERLAY(true)

      this.NEXT_COUNCIL_STATUS({
        'council_id': this.GETTERS_COUNCIL_ALL.id,
      })
      .then(res => {
        if(res.status){
          this.$messageHelper(`Статус совета успешно изменен`, 'success', 5000)
          this.council_status_change_dialog = false
          this.$emit('updateParent', {item: -1, close_modal: false})
          this.reload_council()

        }
        else{
          this.UPDATE_OVERLAY(false)
          if(res.errors !== undefined){
            this.$messageHelper(res.errors.join(', '), 'error', 5000)
          }
          else
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        }
      })

    },

    export_council_word(id){
      this.UPDATE_OVERLAY(true)
      this.UPLOAD_COUNCIL_TO_DOCX(this.GETTERS_COUNCIL_ALL.id)
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          window.open(res.url, '_blank');
        })
        .catch((e) => this.UPDATE_OVERLAY(false));
    },

    export_report(id){
      this.UPDATE_OVERLAY(true)
      const proposal_ids = [];

      this.GETTERS_COUNCIL_ALL.proposals_council.forEach((item) => {
        proposal_ids.push(item.proposal_id);
      });

      this.UPLOAD_LIST_TO_EXCEL({proposal_ids: proposal_ids, type_id: 21})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          window.open(res.url, '_blank');
        })
        .catch(() => this.UPDATE_OVERLAY(false));
    },

    export_council_excel(id){
      this.UPDATE_OVERLAY(true)
      const proposal_ids = [];

      this.GETTERS_COUNCIL_ALL.proposals_council.forEach((item) => {
        proposal_ids.push(item.proposal_id);
      });

      this.UPLOAD_LIST_TO_EXCEL({proposal_ids: proposal_ids, type_id: 4})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          window.open(res.url, '_blank');
        })
        .catch(() => this.UPDATE_OVERLAY(false));
    },

    export_pdf(id){
      this.UPDATE_OVERLAY(true)
      const proposal_ids = [];

      this.GETTERS_COUNCIL_ALL.proposals_council.forEach((item) => {
        proposal_ids.push(item.proposal_id);
      });

      this.GET_URL_PRD(proposal_ids)
        .then(() => this.UPDATE_OVERLAY(false))
        .catch(() => this.UPDATE_OVERLAY(false));
    },

    council_status(id){
      if(id == 1)
        return 'Принять'
      else if(id == 2)
        return 'Отклонить'
      else if(id == 3)
        return 'На доработку'
      else if(id == 4)
        return 'Рассмотреть позднее'
      else
        return 'Не определено'
    },

    row_classes(item) {
      if(this.GETTERS_COUNCIL_ALL.status == 1){
        if(item.avarage == 0)
          return "orange_bg";
        else
          return "green_bg";
      }
      else if(this.GETTERS_COUNCIL_ALL.status == 2 || this.GETTERS_COUNCIL_ALL.status == 3){
        if(item.status == 1)
          return "green_bg";
        else if (item.status == 2)
          return "red_bg";
        else
          return "gray_bg";
      }
      else if(this.GETTERS_COUNCIL_ALL.status == 5){
        if (item.status == 2)
          return "red_bg";
        else
          return "";
      }
      else{
        return "gray_bg";
      }
    },

    make_editable_mark(item){
      if(this.GETTERS_COUNCIL_ALL.status == 1 || this.GETTERS_COUNCIL_ALL.status == 2){
        this.new_mark = item.avarage
        this.changable_id = item.id
        this.mark_change_dialog = true
      }
    },

    make_editable_duration(item){
      if(this.GETTERS_COUNCIL_ALL.status == 2){
        this.changable_id = item.id
        this.new_duration = this.old_duration = item.provided_experiment_duration > 0 ? item.provided_experiment_duration : 0
        this.duration_change_dialog = true
      }
    },

    make_editable_solution(item){
      if(this.GETTERS_COUNCIL_ALL.status == 2){
        this.changable_id = item.id
        this.new_solution = 0
        this.solution_change_dialog = true
      }
    },

    make_editable_comment(item){
      if(this.GETTERS_COUNCIL_ALL.status == 2){
        this.changable_id = item.id
        this.changable_solution = item.status
        this.new_comment = item.comment
        this.is_modal_reason = null
        this.comment_change_dialog = true
      }
    },

    save_correct_mark(){
      var dataChangeSolution = {
        'action': 'change_mark',
        'new_mark': this.new_mark,
      };
      this.update_council_proposal_decision(dataChangeSolution)
    },

    save_correct_comment(){
      var dataChangeSolution = {
        'action': 'change_comment',
      };

      if (this.changable_solution == 2 && !this.new_comment.length){
        this.$messageHelper(this.$t('leave_comment'), 'error', 3000);
        return;
      }

      dataChangeSolution['comment'] = this.new_comment

      this.update_council_proposal_decision(dataChangeSolution)
    },

    save_correct_solution(){
      var dataChangeSolution = {
        'action': 'change_solution',
        'solution': this.new_solution,
      };

      this.update_council_proposal_decision(dataChangeSolution)
    },

    save_correct_duration(){
      var dataChangeSolution = {
        'action': 'change_duration',
        'provided_experiment_duration': this.new_duration,
      };

      this.update_council_proposal_decision(dataChangeSolution)
    },

    update_council_proposal_decision(args){
      this.UPDATE_OVERLAY(true)
      args['council_id'] = this.GETTERS_COUNCIL_ALL.id
      args['proposal_council_id'] = this.changable_id

      this.CHANGE_COUNCIL_PROPOSAL_SOLUTION(args)
      .then(res => {
        if(res.status){
          this.reload_council()
          this.solution_change_dialog = false
          this.mark_change_dialog = false
          this.duration_change_dialog = false
          this.comment_change_dialog = false
        }
        else{
          this.UPDATE_OVERLAY(false)
          if(res.errors !== undefined){
            this.$messageHelper(res.errors.join(', '), 'error', 5000)
          }
          else
            this.$messageHelper(`что-то пошло не так... попробуйте перезагрузить страницу`, 'error', 5000)
        }
      })
    },

    calc_all_avarage(proposals){
      proposals.forEach((item) => {
        if(item.correct_mark > 0){
          item.old_mark = this.calculate_avarage(item.proposal.proposals_expertise)
          item.avarage = item.correct_mark
        }
        else{
          item.old_mark = -1
          item.avarage = this.calculate_avarage(item.proposal.proposals_expertise)
        }
      });
      return proposals
    },

    calculate_avarage(recs){
      var cnt = 0, sum = 0
      recs.forEach((rec) => {
        // if(!rec.is_finalised){
        if(rec.council_id == this.GETTERS_COUNCIL_ALL.id){
          if(rec.mark > 0){
            cnt = cnt + 1
            sum = sum + rec.mark
          }
        }
      });

      if(sum == 0 || cnt == 0)
        return 0
      else
        return sum/cnt
    },

    close_council_dialog(){
      this.$emit('closeCouncilDialog');
    },

    recalcStations(){
      this.stations = {}
      this.all_proposals.forEach(item => {
        this.stations[item['proposal']['station_id']] =  {
          id: item['proposal']['station_id'],
          descr: item['proposal']['station'],
          full_station_events: []
        }
        this.update_events(item['proposal']['station_id'])
      })
    },

    prepare_data(val){
      this.station_time_provided = 0
      this.station_time_undefined = 0
      this.station_time_rejected = 0
      this.station_time_to_modificate = 0

      if(!val){
        this.filtered_proposals = this.all_proposals
        this.station_time_available = 0
        this.council_station_id = null
      }
      else{
        this.filtered_proposals = []
        this.all_proposals.forEach(item => {
          if(item['proposal']['station_id'] == val){
            this.filtered_proposals.push(item)

            if(item.status == 1){
              this.station_time_provided = this.station_time_provided + parseInt(item.provided_experiment_duration)
            }
            else if(item.status == 2){
              this.station_time_rejected = this.station_time_rejected + parseInt(item.proposal.experiment_duration)
            }
            else if(item.status == 3){
              this.station_time_to_modificate = this.station_time_to_modificate + parseInt(item.proposal.experiment_duration)
            }
            else if(item.status == 4){
              this.station_time_to_modificate = this.station_time_to_modificate + parseInt(item.proposal.experiment_duration)
            }
            else{
              this.station_time_undefined = this.station_time_undefined + parseInt(item.proposal.experiment_duration)
            }
          }
        })

        this.GETTERS_COUNCIL_ALL.council_stations.forEach(item => {
          if(item.station_id == val){
            this.station_time_available = item.available_time
            this.council_station_id = item.id
          }
        })

      }
    },

    update_events(station_id){
      if(station_id > 0){
        var res = this.GETTERS_STATION_CALENDAR(station_id);
        if(!res){
          setTimeout(() => {
              this.update_events(station_id)
          }, 1000)
        }
        else{
          if(res.loaded){
            this.stations[station_id]['full_station_events'] = []

            res.calendars.forEach(calendar_item => {
              var name = ''
              if(calendar_item.type == 2 || calendar_item.type == 5){
                name = calendar_item.proposal_id + ' ' + calendar_item.proposal_applicant
              }
              else{
                name = calendar_item.experiment_name ??  'без названия'
              }

              this.stations[station_id]['full_station_events'].push({
                name:  name ,
                start: this.formate_date_for_cal(calendar_item.start_date, true),
                end: this.formate_date_for_cal(calendar_item.finish_date, false),
                source: calendar_item,
                id: calendar_item.id,
                type: calendar_item.type,
              })
            })

          }
          else{
            this.load_calendar(station_id)
          }

        }
      }
    },

    async load_calendar(station_id){
      if(station_id > 0){
        this.GET_CALENDAR_LIST({station_id:station_id})
        .then(() => {
          this.update_events(station_id);
        })
      }
    },

    formate_datetimeinterval(item){
      var date_obj_1 = new Date(item.source.start_date)
      var date_obj_2 = new Date(item.source.finish_date)
      var diff = (date_obj_2 - date_obj_1) / 3600000

      return this.formate_datetime(date_obj_1) + ' : ' + this.formate_datetime(date_obj_2) + ' (' + diff.toFixed(1) + ' ч.)'
    },

    formate_datetime(str){
      var date_obj = new Date(str)
      var month = date_obj.getMonth() + 1
      var date = date_obj.getDate()
      var m = date_obj.getMinutes()
      var h = date_obj.getHours()
      if (h<10) h = '0'+h
      if (m<10) m = '0'+m
      if (month<10) month = '0' + month
      if (date<10) date = '0' + date

      return date + '.' + month + '.' + date_obj.getFullYear() + ' ' + h + ':' + m
    },

    formate_date_for_cal(str, with_one){
      var dd_cal = new Date(str)
      var min = dd_cal.getMinutes()
      if (min === 0 && with_one) min = '1'
      const formatted = `${dd_cal.getFullYear()}-${(dd_cal.getMonth()+1)}-${dd_cal.getDate()} ${dd_cal.getHours()}:${min}`
      return formatted
    },

    _updateText: (str) => str.replace(/\n/g, '\u003cbr\u003e'),

  },

  watch:{
    is_modal_reason(val){
      if(val && val.length > 0){
        var t = []
        if(this.new_comment){
         t = this.new_comment.split('.; ')

          if(t.length > 1)
            t.splice(0,1)
        }

        let full_comment = '';

        if(this.is_modal_reason && this.is_modal_reason.length){
          this.is_modal_reason.forEach((item, i) => {
            full_comment += ( (!i ? 'Причина отклонения:  ' :', ') + item);
          });
          full_comment += '.; ';
        }
        full_comment += t.join(', ');

        this.new_comment = full_comment
      }
    },

    new_solution(val){
      if (val > 0){
        this.save_correct_solution()
      }
    },

    selected_station(val){
      this.prepare_data(val)
    },

    GETTERS_COUNCIL_ALL(val) {
      this.reload_headers()

      this.filtered_proposals = this.all_proposals = this.calc_all_avarage(this.GETTERS_COUNCIL_ALL.proposals_council)
      this.recalcStations()
      this.prepare_data(this.selected_station)

      this.start_time = this.GETTERS_COUNCIL_ALL.start_time.substring(0,5)
      // this.start_time = this.GETTERS_COUNCIL_ALL.start_time ? `${this.GETTERS_COUNCIL_ALL.start_time}` : `00:00`
    },

    GETTERS_USER_ID_TEAM(val) {
      if (this.team.length !== 0) {
        this.team.forEach(item => {
          if (item.id !== val.id) {
            this.team.push(val)
          } else {
            this.$messageHelper(this.$t('Step5.member_name__already_been_added'), 'error', 5000)
          }
        })
      } else {
        this.team.push(val)
      }
    },

    GETTERS_INDIVIDUAL(val) {
      if (val.length !== 0)
        val.forEach(item => {
          this.individual.push({
          id: item.profile_id,
          name: `${item.last_name} ${item.first_name} ${item.middle_name} `
        })
      })
    },

    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
      if(val && val == this.call_id){
        this.reload_council()
      }
    },

    GETTERS_NEED_RELOAD_CALENDAR(val){
      if(val){
        this.reload_council()
      }
    },
  },
};
</script>

<style scoped>
.main-card {
  background-color: #f4f5f7 !important;
  border-radius: 2px;
}
.my-green{
  color:#62ba02 !important;
}
.main-card * {
  color: #15336d;
}
.comment-expert,
.comment-bs {
  max-height: 40vh;
  overflow-y: auto;
  padding: 10px;
  padding-bottom: 15px;
}
.comment-expert {
  padding-top: 0;
}
.comment-bs *{
  color: #15336d !important;
}
.my-primary{
  color: #15336d !important;
}
.modal-mul-select{
    padding-top: 0px;
    padding-right: 24px;
    padding-bottom: 20px;
    padding-left: 24px;
}
.vertical-header-cell{
  transform:rotate(-40deg);
    /* writing-mode: vertical-lr;  */
     /* text-orientation: upright;  */
}
  .input-container__search-user,
  .input-container__search-result {
      max-width: auto;
      width: 100%;
  }
  .input-container__search-user {
    min-width: 300px;
  }

</style>
